module.exports = __webpack_public_path__ + "img/icon_help_coord.3ff8e17d.svg";